import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
  
})
export class NotFoundComponent implements OnInit {

  constructor(private translate: TranslateService) { 
    this.cargarLenguaje();
  }

  ngOnInit(): void {
  }

  cargarLenguaje(){
   
    this.translate.addLangs(['es', 'en', 'pt']);
    this.translate.setDefaultLang('es');
    this.translate.use('es');

    
    if(localStorage.getItem('lenguaje') != null) {
      this.translate.use(localStorage.getItem('lenguaje'));
    } else {
      this.translate.use(this.translate.getDefaultLang());
    }
    
  }

}
